import { Moment } from "moment";
import { ContentTable, DynamicRowSize, Table } from "pdfmake/interfaces";
import { MonatsabschlussZeile } from "@/api/Abrechnung";
import { currentTimestamp, MONATSNAMEN } from "@/api/Termine";
import { getQuittungRechnungFooter, getQuittungRechnungHeader } from "./common";
import { borderBottom, noBorder } from "../pdfStyles";
import { format } from "../util";

export function createRechnungsblatt(
  monat: Moment,
  zeile: MonatsabschlussZeile
): ContentTable {
  if (!zeile.rechnungsdatum) {
    zeile.rechnungsdatum = currentTimestamp().format("DD.MM.YYYY");
  }

  const monatsZahl = monat.month() + 1;
  const mwstProzent =
    monat.year() == 2020 && monatsZahl >= 7 && monatsZahl <= 12 ? 16 : 19;

  const table: Table = {
    widths: [100, "*", 95, 95, 100],
    heights: ((rowNumber: number) => 5) as DynamicRowSize,
    body: [
      ...getQuittungRechnungHeader(zeile),
      [
        { text: "Rechnung Nr.", style: "header", },
        { text: zeile.rechnungsnummer, fontSize: 16, alignment: "right", },
        {},
        {},
        {},
      ],
      [
        { text: "Zimmernutzung", style: "fett" },
        { text: "Im Monat", style: "fett", alignment: "right" },
        {
          text: MONATSNAMEN[monat.month()] + " / " + monat.year(),
          style: "fett",
        },
        {},
        {},
      ],
      [
        { text: "lt. Anlage", bold: true, },
        {},
        {},
        {
          text: format((zeile.miete * (100 - mwstProzent)) / 100, false, 2),
          alignment: "right",
        },
        {},
      ],
      [
        { border: noBorder, text: "", },
        { border: noBorder, text: "", },
        { border: noBorder, text: `Umsatzsteuer ${mwstProzent}%`, style: "small", },
        {
          text: format((zeile.miete * mwstProzent) / 100, false, 2),
          alignment: "right",
          border: borderBottom,
        },
        { border: noBorder, text: "",} ,
      ],
      [
        {},
        {},
        { text: "Endbetrag", bold: true, alignment: "center", },
        { text: format(zeile.miete, false, 2), alignment: "right", },
        {},
      ],
      ...getQuittungRechnungFooter(zeile),
    ],
  };

  return {
    pageBreak: "before",
    layout: "rechnung", // siehe pdfStyles.ts
    table,
    margin: [35, 40, 30, 25],
  };
}
